export type Product = {
  id: string;
  slug: string;
  name: string;
  category: string;
  brand?: string;
  shortDescription?: string;
  description?: string;
  priceNzdCents: number;
  imageUrls?: string[];
  inStock: boolean;
  stockCount?: number;
  featured?: boolean;
  active?: boolean;
};

export const PRODUCTS: Product[] = [];
